import { ResponseError } from '../../errors';
import { prepareRecommendations } from '../../mappers';
import {
  fetchMobileSiteGetRecommendations,
  TMobileSiteGetRecommendationsResponse,
  IMobileSiteGetRecommendationsRequest,
} from '../../repositories/feed-page/v2/mobile-site/get-recommendations';
import { IApplicationContext } from '../../types/applicationContext';
import { TRecommendationsResult } from './types';

const DEGRADATION_TELEMETRY_KEY = 'degradation.recommendations.mobile';

type TGetRecommendationsParams = {
  parameters: IMobileSiteGetRecommendationsRequest;
  offset?: number;
  cookies?: string;
};

export async function getMobileRecommendations(
  context: IApplicationContext,
  { parameters, offset = 0, cookies }: TGetRecommendationsParams,
): Promise<TRecommendationsResult> {
  const { httpApi, logger, telemetry } = context;

  try {
    const response: TMobileSiteGetRecommendationsResponse = await fetchMobileSiteGetRecommendations({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
        },
      },
    });

    if (response.statusCode !== 200) {
      throw new ResponseError({
        domain: 'getMobileRecommendations',
        message: response.response.message || 'Код ответа не 200',
        details: { errors: JSON.stringify(response.response.errors) },
      });
    }

    return {
      recommendations: prepareRecommendations(response.response.recommendations, offset),
      hasMore: !!response.response.hasMore,
    };
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.warning(error, {
      domain: 'getMobileRecommendations',
      message: 'Не удалось получить список рекомендаций',
    });

    // Повторное выкидывание исключения нужно для asyncThunk
    throw error;
  }
}
